@if (showSpinner || showSpinners ) {
<div
  [style.background-color]="'rgba(255,255, 255, ' + backgroundOpacity + ')'"
  id="spinnerOverlay"
  data-testid="rs-loader"
>
  <div class="center">
    <div>
      <div id='mobi-spinner-container'>
        <mat-spinner
          diameter='67'
          mode='indeterminate'
          strokeWidth='6.67'
        />
      </div>
    </div>
    <h2
      [innerHTML]="currentMessage | translate"
      class="loaderTitle"
    >
    </h2>
  </div>
</div>
}